export default "__VITE_ASSET__Vk1KunrB__"